import React, {useEffect, useRef, useState} from 'react';
import {useLocation} from 'react-router-dom';
import queryString from 'query-string';

import axios from '../../../axios';
import './style.scss';
import { Match } from './match';
import { Rank } from './rank';
import Loading from "../../../components/loading";

function Live(props) { 
    const [gamesData, setGamesData] = useState([]);
    const [loading, setLoading] = useState(null);
    const [leagueId, setLeagueId] = useState(1);
    const [type, setType] = useState('batters');
    const [rankData, setRankData] = useState([]);
    const location = useLocation();
    const date = queryString.parse(location.search).date ?? '';
    const [count, setCount] = useState(0);

    const onClickTab = async (l_id, type_params) => {
        try {
            const {data} = await axios.get(`api/lives/rankings/leagues/${l_id}/${type_params}`);
            setRankData(data);
            setLeagueId(l_id);
            setType(type_params);
        }catch (e) {
            console.log(e)
        }
    }
    const getGamesData = async () => {
        try {
            const [getGames, getRanks] = await Promise.all([
                axios.get('api/lives/games?date=' + date),
                axios.get(`api/lives/rankings/leagues/${leagueId}/${type}`)]);
            setRankData(getRanks.data);
            const getInit = await Promise.all(getGames.data.map(async (item) => {
                const raw = await Promise.all(item.games.map(async (game) => {
                    const {data} = await axios.get(`api/lives/games/${game}`);
                    return data
                }))
                item.games = raw;
                return item;
            }));
            setGamesData(getInit);
            setLoading(false);
        }catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoading(true);
        getGamesData();
        const interval = setInterval(() => {
            setCount(c => (c + 1) % 2);
        }, 30000);
        return () => clearInterval(interval);
    }, []);
    const isFirstRender = useRef(true);
    useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        getGamesData();
    },[count]);

    return (
        <div className="wrap_live">
            <div className="title-live">
                <h3>LIVE
                    <span>
                        <i className="fa fa-question-circle"></i>
                        <div className='tooltips-live'><p>Live</p></div>
                    </span>
                </h3>
            </div>
            {
                !loading ? (
                    <div className="live_container">
                        <Match gamesData={gamesData} history={props.history}/>
                        <Rank rankData={rankData} leagueId={leagueId} type={type} onClickTab={onClickTab}/>
                    </div>
                ) : (<Loading show={loading}/>)
            }
        </div>
    );
}

export default Live;
